import GridTableTemplate from './GridTableTemplate';

export default GridTableTemplate;
